import { useEffect, useState } from "react";
import { Download, X, Share } from "lucide-react";

export default function InstallPrompt() {
  const [evt, setEvt] = useState(null);
  const [ios, setIos] = useState(false);
  const [hidden, setHidden] = useState(() => localStorage.getItem("sc_install_dismissed") === "1");

  useEffect(() => {
    if ("serviceWorker" in navigator) navigator.serviceWorker.register("/sw.js").catch(() => {});
    const standalone = window.matchMedia("(display-mode: standalone)").matches || window.navigator.standalone;
    if (standalone) return;
    const isIos = /iphone|ipad|ipod/i.test(navigator.userAgent) && !window.MSStream;
    setIos(isIos);
    const onPrompt = (e) => { e.preventDefault(); setEvt(e); };
    window.addEventListener("beforeinstallprompt", onPrompt);
    window.addEventListener("appinstalled", () => setEvt(null));
    return () => window.removeEventListener("beforeinstallprompt", onPrompt);
  }, []);

  const dismiss = () => { localStorage.setItem("sc_install_dismissed", "1"); setHidden(true); };
  const install = async () => { evt.prompt(); const r = await evt.userChoice; if (r.outcome === "accepted") setEvt(null); };

  if (hidden || (!evt && !ios)) return null;
  return (
    <div data-testid="install-prompt" className="fixed bottom-4 left-4 right-4 sm:left-auto sm:right-6 sm:w-96 z-40 bg-slate-900 text-white rounded-2xl shadow-2xl p-4 flex items-start gap-3">
      <img src="/icon-192.png" alt="" className="w-12 h-12 rounded-xl" />
      <div className="flex-1">
        <div className="font-bold">Installer TymCoach</div>
        <div className="text-xs text-slate-300 mt-0.5">
          {ios && !evt ? <span className="flex items-center gap-1">Appuyez sur <Share className="w-3.5 h-3.5 inline" /> puis « Sur l'écran d'accueil »</span> : "Accès en un clic depuis l'écran d'accueil, alertes push et plein écran."}
        </div>
        {evt && <button data-testid="install-btn" onClick={install} className="mt-2 sc-btn bg-emerald-500 hover:bg-emerald-400 border-0 text-white text-xs"><Download className="w-3.5 h-3.5" /> Installer l'application</button>}
      </div>
      <button data-testid="install-dismiss" onClick={dismiss} className="p-1 rounded-full hover:bg-white/10" aria-label="Fermer"><X className="w-4 h-4" /></button>
    </div>
  );
}
